<template>
  <ResponsiveLogin v-if="allowNewLogin" />
  <main v-else>
    <div class="gp-main-body-content">
      <Modal :hideExit="true" cClass="mw424">
        <template #header>
          <p class="typo-heading20 typo-medium text-light-high">{{ $t("agency.signin") }}</p>
        </template>
        <template #default>
          <form ref="form" method="GET" :action="actionLink" @submit="checkDomain">
            <div class="form-group">
              <label class="label typo-button14 typo-medium text-light-high">Enter your shop domain to log in or install this app.</label>
              <input class="input-field input-field-block" :class="{ 'is-error': alertText && alertText.length }" name="shop" type="text" required v-focus :title="$t('agency.domain')" placeholder="example.myshopify.com" v-model="domain" />
              <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
            </div>

            <div class="btn-group flex-row-reverse make-default-btn mt-4">
              <button class="btn btn-primary btn-default btn-block">{{ $t("agency.signin") }}</button>
            </div>
          </form>
        </template>
      </Modal>
    </div>

    <PortalTarget name="modals" multiple></PortalTarget>
  </main>
</template>

<script>
import { serverDomain } from "@/config/index.js";
import ResponsiveLogin from "@/core/components/ResponsiveLogin.vue";

export default {
  name: "Login",
  components: {
    ResponsiveLogin
  },
  data() {
    return {
      domain: "",
      allowNewLogin: true,
      alertText: null
    };
  },
  computed: {
    actionLink() {
      return serverDomain() + "/login"
    }
  },
  beforeRouteEnter () {
    window.location.replace('https://apps.shopify.com/gempages')
  },
  created() {},
  mounted() {},
  methods: {
    checkDomain(e) {
      const affix = "myshopify.com";
      // const affixes = [];
      this.alertText = "";
      const pattern = /^([-a-zA-Z0-9@_~]{2,256}\.)+myshopify.com$/;
      const domain = this.domain || this.domain.trim() || "";
      try {
        if (!domain || !domain.length) {
          throw new Error("Shopify domain should not be empty!")
        }

        if (domain.endsWith(".")) {
          if (domain.indexOf("."+affix) > -1) {
            throw new Error("Shopify domain should end with \".myshopify.com\"");
          }
          const autoDomain = domain + affix;
          if (pattern.test(autoDomain)) {
            this.domain = autoDomain;
            return true;
          } else {
            throw new Error("Shopify domain should end with \".myshopify.com\"");
          }
        } else {
          if (domain.indexOf("."+affix) > -1) {
            return true
          }
          const autoDomain = domain + "." + affix;
          if (pattern.test(autoDomain)) {
            this.domain = autoDomain;
            return true;
          } else {
            throw new Error("Shopify domain should end with \".myshopify.com\"");
          }
        }
      } catch (err) {
        this.alertText = err.message;
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .btn-default {
  min-width: 120px;
}
.floating-text {
  top: -18px;
  min-width: 120px;
  text-align: right;
}
</style>
